module.exports = __webpack_public_path__ + "static/media/s_orange.240d8d8d.mp3";